/* eslint-disable prettier/prettier */
import axios from 'axios'

const API_BASE = process.env.REACT_APP_API_URL || 'https://dm.aibuddyassistant.com/api'

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
})

export const getTeamMembers = async () => {
  const res = await axios.get(`${API_BASE}/team/members`, { headers: headers() })
  return res.data
}

export const inviteMember = async (email, role) => {
  const res = await axios.post(`${API_BASE}/team/invite`, { email, role }, { headers: headers() })
  return res.data
}

export const updateMemberRole = async (memberId, role) => {
  const res = await axios.patch(`${API_BASE}/team/members/${memberId}/role`, { role }, { headers: headers() })
  return res.data
}

export const removeMember = async memberId => {
  const res = await axios.delete(`${API_BASE}/team/members/${memberId}`, { headers: headers() })
  return res.data
}

export const cancelInvitation = async invitationId => {
  const res = await axios.delete(`${API_BASE}/team/invitations/${invitationId}`, { headers: headers() })
  return res.data
}

export const resendInvitation = async invitationId => {
  const res = await axios.post(`${API_BASE}/team/invitations/${invitationId}/resend`, {}, { headers: headers() })
  return res.data
}

export const getInvitation = async token => {
  const res = await axios.get(`${API_BASE}/team/accept/${token}`)
  return res.data
}

export const acceptInvitation = async token => {
  const res = await axios.post(`${API_BASE}/team/accept/${token}`)
  return res.data
}
